import React, { Component } from "react"
import { Panel, DefaultButton, Checkbox, PanelType } from "office-ui-fabric-react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {getEditorConfig} from "f3-admin-editor/lib/helpers";
import {getIsCreation} from "f3-admin-editor/lib/selectors";

const promiseWaterfall = callbacks => {
	return callbacks.reduce((acc, cb) => {
		return acc.then(cb)
	}, Promise.resolve())
}

const getLabelByFieldName = model => {
	return model.reduce((acc, item) => {
		const { type } = item
		switch (type) {
			case "subtitle":
			case "separator":
			case "customComponent":
				return acc
			case "groups":
				return Object.assign(acc, ...item.groups.map(({ items }) => getLabelByFieldName(items)))
			case "aside":
				return Object.assign(acc, { [`asides-${item.options.handler}`]: item.label })
			default:
				return Object.assign(acc, { [item.fieldName]: item.label })
		}
	}, {})
}

const mapStateToProps = (state) => ({
	token: state.login.token,
})

const getDuplicateProduct = ({ baseFields, langs, relations, asides: enabledAsides }) => {
	class DuplicateProduct extends Component {
		static contextTypes = {
			apiUrl: PropTypes.string
		}

		constructor(props) {
			super(props)
			this.labelByFieldName = getLabelByFieldName(this.props.model)
			this.state = {
				showPanel: false,
				success: false,
				langs: langs.reduce((acc, lang) => {
					acc[lang] = true
					return acc
				}, {})
			}
		}

		initBody = () => {
			const { currentContent } = this.props
			const body = this.body = relations.reduce((acc, { field }) => {
				if (field === "attachments") {
					acc[field] = currentContent.attachments ? currentContent.attachments.map(({ permalink }) => permalink) : []
				} else {
					acc[field] = true
				}
				return acc
			}, {})
			baseFields.forEach(field => {
				if (this.props.currentContent[field]) {
					body[field] = this.props.currentContent[field]
				}
			})
			if (this.props.currentContent.asides) {
				this.props.currentContent.asides.forEach(aside => {
					if (body.asides) {
						body.asides[aside.handler] = aside
					} else {
						body.asides = {[aside.handler]: aside}
					}
				})
			}
		}

		sync = () => this.props.handleSave(() => {
			const { currentContent, template } = this.props
			console.log("currentContent", currentContent)
			const { apiUrl } = this.context

			return Promise.all(langs.filter(lang => lang !== currentContent.lang && this.state.langs[lang]).map(lang => {
				const body = { ...this.body }
				const promises = relations.reduce((acc, { namespace, model, handlers, field }) => {
					if (field !== "attachments" && body[field]) {
						if (currentContent[field] && currentContent[field].length) {
							const query = {
								where: {
									lang,
									id: {
										operator: "in",
										value: currentContent[field].map(({id}) => id)
									}
								}
							}
							acc.push(fetch(`${this.context.apiUrl}/${namespace}/${model}${query ? `?params=${JSON.stringify(query)}` : ""}`)
								.then(res => res.json())
								.then(({data}) => {
									body[field] = data.map(item => handlers.reduce((acc, handler) => {
										acc[handler] = item[handler]
										return acc
									}, {}))
								}))
						} else {
							body[field] = []
						}
					}
					return acc
				}, [])
				if (body.asides) {
					body.asides = Object.values(body.asides).reduce((acc, aside) => {
						if (aside.body) {
							acc.push(Object.assign({}, aside, {lang, body: typeof aside.body === "object" ? JSON.stringify(aside.body) : aside.body.toString()}))
						}
						return acc
					}, [])
				}
				Promise.all(promises)
					.then(() => {
						const query = {
							relations: [],
							where: {
								lang: currentContent.lang,
								permalink: `${currentContent.permalink}-1`
							}
						}
						return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}?params=${JSON.stringify(query)}`).then(res => res.json()).then(({ data: [{ id }] }) => id)
					})
					.then(id => {
						const query = {
							relations: ["asides", "attachments"],
							where: {
								lang,
								id
							}
						}
						return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}?params=${JSON.stringify(query)}`)
							.then(res => res.json())
							.then(({ count, data }) => {
								if (count) {
									const [ { permalink, asides: dataAsides, attachments: dataAttachments } ] = data
									if (body.asides && dataAsides && dataAsides.data) {
										body.asides = Object.values([...dataAsides.data, ...body.asides].reduce((acc, aside) => {
											acc[aside.handler] = aside
											return acc
										}, {}))
									}
									if (body.asides) {
										body.asides = body.asides.map(item => {
											if (item.body === null) {
												item.body = ""
											} else {
												item.body = typeof item.body === "object" ? JSON.stringify(item.body) : item.body.toString()
											}
											return item
										})
									}

									const mustSyncAttachments = this.props.model.some(({type, options}) => type === "aside" && options.type === "attachment")
									if (!body.attachments) {
										if (mustSyncAttachments) {
											body.attachments = []
											if (dataAttachments && dataAttachments.data) {
												body.attachments.push(...dataAttachments.data.map(({ permalink }) => ({ permalink, lang })))
											}
											if (currentContent.attachments) {
												body.attachments.push(...currentContent.attachments.map(({ permalink }) => ({ permalink, lang })))
											}
										}
									} else {
										body.attachments = body.attachments.map(permalink => ({ permalink, lang }))
										if (dataAttachments && dataAttachments.data) {
											body.attachments.push(...dataAttachments.data.map(({ permalink }) => ({ permalink, lang })))
										}
									}
									body.attachments = body.attachments && body.attachments.filter(({ permalink: mainPermalink }, i, array) => {
										return i === array.findIndex(({ permalink }) => mainPermalink === permalink)
									})
									return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}/${lang}/${permalink}`, {
										method: "PUT",
										headers: {
											Authorization: this.props.token,
											"Content-Type": "application/json"
										},
										body: JSON.stringify(body)
									})
								} else {
									if (body.asides) {
										body.asides = body.asides.map(item => {
											if (item.body === null) {
												item.body = ""
											} else {
												item.body = typeof item.body === "object" ? JSON.stringify(item.body) : item.body.toString()
											}
											return item
										})
									}
									if(body.attachments){
										body.attachments = body.attachments.map(attachment => ({
											permalink: attachment
										}))
									}
									return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}`, {
										method: "POST",
										headers: {
											Authorization: this.props.token,
											"Content-Type": "application/json"
										},
										body: JSON.stringify(Object.entries(Object.assign(template.list.commonFields[lang], currentContent, body, { id, lang, permalink: `${currentContent.permalink}-1`, name: `${currentContent.name} 1` })).reduce((acc, [key, value]) => {
											if (value !== null) {
												if (key === "asides") {
													acc[key] = Object.values(value)
												} else if (key === "attachments") {
													acc[key] = value.map(({ permalink }) => ({ permalink, lang }))
												} else {
													acc[key] = value
												}
											}
											return acc
										}, {}))
									})
								}
							})
					})
			}))
		}).then(() => this.setState({ success: true }))

		duplicate = () => this.props.handleSave(() => {
			const { currentContent, template } = this.props
			console.log("currentContent", currentContent)
			const { apiUrl } = this.context

			const body = { ...this.body }
			const lang = currentContent.lang
			const promises = relations.reduce((acc, { namespace, model, handlers, field }) => {
				if (field !== "attachments" && body[field]) {
					if (currentContent[field] && currentContent[field].length) {
						const query = {
							where: {
								lang,
								id: {
									operator: "in",
									value: currentContent[field].map(({id}) => id)
								}
							}
						}
						acc.push(fetch(`${this.context.apiUrl}/${namespace}/${model}${query ? `?params=${JSON.stringify(query)}` : ""}`)
							.then(res => res.json())
							.then(({data}) => {
								body[field] = data.map(item => handlers.reduce((acc, handler) => {
									acc[handler] = item[handler]
									return acc
								}, {}))
							}))
					} else {
						body[field] = []
					}
				}
				return acc
			}, [])

			if (body.asides) {
				body.asides = Object.values(body.asides).reduce((acc, aside) => {
					if (aside.body) {
						acc.push(Object.assign({}, aside, {lang, body: typeof aside.body === "object" ? JSON.stringify(aside.body) : aside.body.toString()}))
					}
					return acc
				}, [])
			}

			return Promise.all(promises)
				.then(() => {
					const query = {
						relations: ["asides", "attachments"],
						where: {
							lang,
							permalink: `${currentContent.permalink}-1`
						}
					}
					return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}?params=${JSON.stringify(query)}`)
						.then(res => res.json())
						.then(({ count, data }) => {
							if (count) {
								const [ { permalink, asides: dataAsides, attachments: dataAttachments } ] = data
								if (body.asides && dataAsides && dataAsides.data) {
									body.asides = Object.values([...dataAsides.data, ...body.asides].reduce((acc, aside) => {
										acc[aside.handler] = aside
										return acc
									}, {}))
								}
								if (body.asides) {
									body.asides = body.asides.map(item => {
										if (item.body === null) {
											item.body = ""
										} else {
											item.body = typeof item.body === "object" ? JSON.stringify(item.body) : item.body.toString()
										}
										return item
									})
								}

								const mustSyncAttachments = this.props.model.some(({type, options}) => type === "aside" && options.type === "attachment")
								if (!body.attachments) {
									if (mustSyncAttachments) {
										body.attachments = []
										if (dataAttachments && dataAttachments.data) {
											body.attachments.push(...dataAttachments.data.map(({ permalink }) => ({ permalink, lang })))
										}
										if (currentContent.attachments) {
											body.attachments.push(...currentContent.attachments.map(({ permalink }) => ({ permalink, lang })))
										}
									}
								} else {
									body.attachments = body.attachments.map(permalink => ({ permalink, lang }))
									if (dataAttachments && dataAttachments.data) {
										body.attachments.push(...dataAttachments.data.map(({ permalink }) => ({ permalink, lang })))
									}
								}
								body.attachments = body.attachments && body.attachments.filter(({ permalink: mainPermalink }, i, array) => {
									return i === array.findIndex(({ permalink }) => mainPermalink === permalink)
								})
								return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}/${lang}/${permalink}`, {
									method: "PUT",
									headers: {
										Authorization: this.props.token,
										"Content-Type": "application/json"
									},
									body: JSON.stringify(body)
								})
							} else {
								if (body.asides) {
									body.asides = body.asides.map(item => {
										if (item.body === null) {
											item.body = ""
										} else {
											item.body = typeof item.body === "object" ? JSON.stringify(item.body) : item.body.toString()
										}
										return item
									})
								}
								if(body.attachments){
									body.attachments = body.attachments.map(attachment => ({
										permalink: attachment
									}))
								}
								return fetch(`${apiUrl}/${template.api.namespace}/${template.api.model}`, {
									method: "POST",
									headers: {
										Authorization: this.props.token,
										"Content-Type": "application/json"
									},
									body: JSON.stringify(Object.entries(Object.assign(template.list.commonFields[lang], currentContent, body, { lang, permalink: `${currentContent.permalink}-1`, name: `${currentContent.name} 1` })).reduce((acc, [key, value]) => {
										if (value !== null) {
											if (key === "asides") {
												acc[key] = Object.values(value)
											} else if (key === "attachments") {
												acc[key] = value.map(({ permalink }) => ({ permalink, lang }))
											} else if (!["id"].includes(key)) {
												acc[key] = value
											}
										}
										return acc
									}, {}))
								})
							}
						})
				})
		}).then(this.sync)

		render() {
			const { currentContent } = this.props
			const { asides } = currentContent
			return [
				<DefaultButton
					primary
					text = { "Duplicate" }
					onClick = { () => {
						this.setState(() => ({ showPanel: true }), this.initBody)
					} }
				/>,
				<Panel
					isOpen={this.state.showPanel}
					type={PanelType.medium}
					onDismiss={ () => this.setState(() => ({ showPanel: false, success: false })) }
				>
					<h2>Campi base</h2>
					{
						baseFields.map(field => {
							return <Checkbox
								defaultChecked
								label={this.labelByFieldName[field]}
								onChange = { (e, checked) => {
									if (checked) {
										this.body[field] = currentContent[field]
									} else {
										delete this.body[field]
									}
								}}
								style = {{ marginTop: "30px !important" }}
							/>
						})
					}
					{
						relations.map(group => {
							const {field} = group
							if (field === "attachments") {
								return [
									<h2>{ this.labelByFieldName[field] }</h2>,
									...(currentContent.attachments ? currentContent.attachments.map(({ fileName, permalink }) => {
										return <Checkbox
											defaultChecked
											label={fileName}
											onChange={(e, checked) => {
												if (checked) {
													if (this.body[field]) {
														this.body[field].push(permalink)
													} else {
														this.body[field] = [permalink]
													}
												} else {
													this.body[field] = this.body[field].filter(permalink2Filter  => permalink2Filter !== permalink)
												}
											}}
											style={{marginTop: "30px !important"}}
										/>
									})  : [])
								]
							} else if (this.labelByFieldName[field]) {
								return <Checkbox
									defaultChecked
									label={this.labelByFieldName[field]}
									onChange={(e, checked) => {
										if (checked) {
											this.body[field] = true
										} else {
											delete this.body[field]
										}
									}}
									style={{marginTop: "30px !important"}}
								/>
							}
						})
					}
					{
						enabledAsides && asides && asides.length !== 0 && [
							<h2>Campi aggiuntivi</h2>,
							...asides.map(aside => {
								const { handler, type, body } = aside
								return <Checkbox
									defaultChecked
									label={`${this.labelByFieldName[`asides-${handler}`]}${type !== "attachment" ? ` → ${type === "coordinates" ? `(${body.lat}, ${body.lng})`: body}` : ""}`}
									onChange = { (e, checked) => {
										if (checked) {
											this.body.asides[handler] = aside
										} else {
											delete this.body.asides[handler]
										}
									}}
									style = {{ marginTop: "30px !important" }}
								/>
							})
						]
					}
					<h2>Lingue da replicare</h2>
					{
						langs.filter(lang => lang !== currentContent.lang).map(lang => {
							return <Checkbox
								defaultChecked
								label={lang.toUpperCase()}
								onChange = { (e, checked) => {
									this.setState(({ langs }) => {
										langs[lang] = checked
										return { langs }
									})
								}}
								style = {{ marginTop: "30px !important" }}
							/>
						})
					}
					<DefaultButton
						style = {{ marginTop: "30px" }}
						primary
						text = { "Duplicate" }
						onClick = { this.duplicate }
					/>
					{
						this.state.success && <h1>FATTO</h1>
					}
				</Panel>
			]
		}
	}

	return connect(mapStateToProps, null)(DuplicateProduct)
}

export default getDuplicateProduct



// WEBPACK FOOTER //
// src/custom/components/DuplicateProduct.js